import { TinyEmitter } from 'tiny-emitter';
import { Browser } from '../utils/audio';
import eventBus from '@/services/eventBus.service';
export class CarTaskExecutor extends TinyEmitter {
  constructor(context) {
    super();
    this.audioElement = new Audio(); //document.createElement('audio');
    this.initEvents();
    this.stopAutoTimer = null;
    this.context = context;
    this.currentAudioIndex = 0;
    this.muted = false;
  }
  /**
   * 音频事件顺序：loadstart->durationchange->loadedmetadata->loadeddata->canplay->canplaythrough
   */
  initEvents() {
    this.audioElement.addEventListener('ended', () => {
      if (this.currentAudioIndex <= this.context.length - 1) {
        this.execute(this.context[this.currentAudioIndex]);
      } else {
        eventBus.$emit('directiveLeaveGuide');
        this.currentAudioIndex = 0;
      }
    });
    this.audioElement.addEventListener('error', (error) => {
      console.error('audio play error', error);
      this.execute(this.context[this.currentAudioIndex]);
    });
  }
  /**
   * 执行
   */
  execute(task, currentAudioIndex = -1) {
    if (currentAudioIndex !== -1) {
      this.currentAudioIndex = currentAudioIndex;
    }
    if (task === null) {
      task = this.context[0];
    }
    this.context.preTask = this.context.currentTask;
    this.context.currentTask = task;
    if (task && task.soundUrl) {
      this.setPlayerUrl(task.soundUrl);
      this.currentAudioIndex++;
      this.emit('audioContent', task);
    } else if (task && !task.soundUrl) {
      console.error('没有找到录音文件地址！');
    }
  }
  /**
   * 设置音频文件地址
   * @param url
   */
  setPlayerUrl(url) {
    this.audioElement.src = url;
    this.audioElement.currentTime = 0;
    this.audioElement.autoplay = true;
    this.audioElement.load();
  }
  /**
   * 开始
   */
  play() {
    if (this.audioElement.src !== Browser.Audio.emptyAudioUrl) {
      this.audioElement.play();
    }
  }
  /**
   * 暂停
   */
  pause() {
    this.audioElement.pause();
  }
  /**
   * 取消任务
   */
  stop() {
    setTimeout(() => {
      this.audioElement = null;
    }, 5);
  }
  /**
   *
   * @param muted 切换静音
   */
  toggleMute(muted = undefined) {
    if (muted !== undefined) {
      this.audioElement.muted = muted;
    } else {
      this.audioElement.muted = !this.audioElement.muted;
    }

    if (this.audioElement.muted) {
      this.pause();
    } else {
      this.play();
    }
    this.muted = this.audioElement.muted;
    return this.audioElement.muted;
  }
  getMuted() {
    return this.muted;
  }
}
